import React from "react";
import "../App.css";
import { Pagination } from "./Pagination";

export function Footer({
  checkedDivisions,
  pageCount,
  pageNumber,
  onPageChange,
}) {
  return (
    <div className="footer">
      <Pagination
        checkedDivisions={checkedDivisions}
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={onPageChange}
      />
    </div>
  );
}
